export default Object.freeze({
    CREATED: 'CREATED',
    DECLINED: 'DECLINED',
    CANCELLED: 'CANCELLED',
    INSURANCE_AUTH_PENDING: 'INSURANCE_AUTH_PENDING',
    PATIENT_VISIT_PENDING: 'PATIENT_VISIT_PENDING',
    RESCHEDULE_REQUESTED: 'RESCHEDULE_REQUESTED',
    RESCHEDULE_AVAILABILITY_CHANGE: 'RESCHEDULE_AVAILABILITY_CHANGE',
    CONSULTATION_NOTES_PENDING: 'CONSULTATION_NOTES_PENDING',
    NO_SHOW: 'NO_SHOW',
    COMPLETED: 'COMPLETED',
})
